var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2117595477(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#D87A82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 7.0625C11.5637 7.0625 7.5625 11.0637 7.5625 16C7.5625 20.9363 11.5637 24.9375 16.5 24.9375C21.4363 24.9375 25.4375 20.9363 25.4375 16C25.4375 11.0637 21.4363 7.0625 16.5 7.0625ZM17.1875 13.25C17.1875 13.0677 17.1151 12.8928 16.9861 12.7639C16.8572 12.6349 16.6823 12.5625 16.5 12.5625C16.3177 12.5625 16.1428 12.6349 16.0139 12.7639C15.8849 12.8928 15.8125 13.0677 15.8125 13.25V15.3125H13.75C13.5677 15.3125 13.3928 15.3849 13.2639 15.5139C13.1349 15.6428 13.0625 15.8177 13.0625 16C13.0625 16.1823 13.1349 16.3572 13.2639 16.4861C13.3928 16.6151 13.5677 16.6875 13.75 16.6875H15.8125V18.75C15.8125 18.9323 15.8849 19.1072 16.0139 19.2361C16.1428 19.3651 16.3177 19.4375 16.5 19.4375C16.6823 19.4375 16.8572 19.3651 16.9861 19.2361C17.1151 19.1072 17.1875 18.9323 17.1875 18.75V16.6875H19.25C19.4323 16.6875 19.6072 16.6151 19.7361 16.4861C19.8651 16.3572 19.9375 16.1823 19.9375 16C19.9375 15.8177 19.8651 15.6428 19.7361 15.5139C19.6072 15.3849 19.4323 15.3125 19.25 15.3125H17.1875V13.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2117595477);
export default __webpack_public_path__ + "static/media/Group 2117595477.31bf71dd2da95431c09ba0fa5b07f38f.svg";
export { ForwardRef as ReactComponent };